import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { MealPlanFilterAmenity } from '__generated__/api';

export const getMealPlanFilterInput = (searchCriteria: SearchCriteriaModel): MealPlanFilterAmenity[] | null => {
  if (searchCriteria.mealPlan && searchCriteria.mealPlan.length > 0) {
    return searchCriteria.mealPlan
      .map(mealType => {
        const result = MealPlanFilterAmenity[MealPlanFilterAmenity[mealType]];

        return result ? result : null;
      })
      .filter(mealType => mealType != null);
  }

  return null;
};
